// Vendors
import { IntlShape } from 'react-intl';
// Constants
import { FINANCIAL_DATA_TOOLTIP_CONSTANTS } from '../constants/financial-data-tooltip.constants';
// Translations
import { INFO_TOOLTIP, TITLE_TOOLTIP } from '../translations/financial-data.tooltip.translations';
// Types
import { TooltipConfigurationType } from './types/financial-data-tooltip.configurations.type';

const getTooltipConfiguration = (
  formatMessage: IntlShape['formatMessage']
): TooltipConfigurationType => ({
  ...FINANCIAL_DATA_TOOLTIP_CONSTANTS,
  content: {
    content: formatMessage({ id: INFO_TOOLTIP }),
  },
  title: {
    content: formatMessage({ id: TITLE_TOOLTIP }),
  },
});

export { getTooltipConfiguration };
